<template>
    <editor-menu-bubble :editor="editor" v-slot="{ commands, isActive }">
        <div class="editor-menubar">
            <text-editor-button title="Bold" :command="commands.bold" :is-active="isActive.bold()">
              <x-icon small>format_bold</x-icon>
            </text-editor-button>

            <text-editor-button title="Italic" :command="commands.italic" :is-active="isActive.italic()">
              <x-icon small>format_italic</x-icon>
            </text-editor-button>

            <text-editor-button title="Underline" :command="commands.underline" :is-active="isActive.underline()">
              <x-icon small>format_underline</x-icon>
            </text-editor-button>

            <text-editor-button title="Strikethrough" :command="commands.strike" :is-active="isActive.strike()">
              <x-icon small>strikethrough_s</x-icon>
            </text-editor-button>

            <text-editor-button title="Bullets" :command="commands.bullet_list" :is-active="isActive.bullet_list()">
                <x-icon small>format_list_bulleted</x-icon>
            </text-editor-button>

            <text-editor-button title="Numbering" :command="commands.ordered_list" :is-active="isActive.ordered_list()">
                <x-icon small>format_list_numbered</x-icon>
            </text-editor-button>

            <text-editor-button title="Insert table" :command="() => commands.createTable({ rowsCount: 3, colsCount: 3, withHeaderRow: false })">
                <x-icon small>border_all</x-icon>
            </text-editor-button>

            <template v-if="isActive.table()">
                <text-editor-button title="Remove table" :command="commands.deleteTable">
                    <delete-table-icon />
                </text-editor-button>

                <text-editor-button title="Insert columns to the left" :command="commands.addColumnBefore">
                    <add-col-before-icon />
                </text-editor-button>

                <text-editor-button title="Insert columns to the right" :command="commands.addColumnAfter">
                    <add-col-after-icon />
                </text-editor-button>

                <text-editor-button title="Delete column" :command="commands.deleteColumn">
                    <delete-col-icon />
                </text-editor-button>

                <text-editor-button title="Insert row above" :command="commands.addRowBefore">
                    <add-row-before-icon />
                </text-editor-button>

                <text-editor-button title="Insert row below" :command="commands.addRowAfter">
                    <add-row-after-icon />
                </text-editor-button>

                <text-editor-button title="Delete row" :command="commands.deleteRow">
                    <delete-row-icon />
                </text-editor-button>

                <text-editor-button title="Merge / unmerge cell" :command="commands.toggleCellMerge">
                    <combine-cells-icon />
                </text-editor-button>
            </template>

            <text-editor-button title="Quote text" :command="commands.blockquote" :is-active="isActive.blockquote()">
                <x-icon small>format_quote</x-icon>
            </text-editor-button>
        </div>
    </editor-menu-bubble>
</template>

<script>
  import TextEditorButton from '~/components/Shared/UIComponents/Editor/TextEditorButton.vue';
  import DeleteTableIcon from '~/components/Shared/UIComponents/Editor/DeleteTableIcon.vue';
  import AddColBeforeIcon from '~/components/Shared/UIComponents/Editor/AddColBeforeIcon.vue';
  import AddColAfterIcon from '~/components/Shared/UIComponents/Editor/AddColAfterIcon.vue';
  import AddRowBeforeIcon from '~/components/Shared/UIComponents/Editor/AddRowBeforeIcon.vue';
  import AddRowAfterIcon from '~/components/Shared/UIComponents/Editor/AddRowAfterIcon.vue';
  import DeleteColIcon from '~/components/Shared/UIComponents/Editor/DeleteColIcon.vue';
  import DeleteRowIcon from '~/components/Shared/UIComponents/Editor/DeleteRowIcon.vue';
  import CombineCellsIcon from '~/components/Shared/UIComponents/Editor/CombineCellsIcon.vue';
  import { EditorMenuBubble } from 'tiptap';

  export default {
    name: 'TextEditorMenu',
    components: {
      TextEditorButton,
      DeleteTableIcon,
      AddColBeforeIcon,
      AddColAfterIcon,
      AddRowBeforeIcon,
      AddRowAfterIcon,
      DeleteColIcon,
      DeleteRowIcon,
      CombineCellsIcon,
      EditorMenuBubble
    },
    props: {
      editor: {
        required: true
      }
    }
  }
</script>
